import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import Logo from "@/components/Logo";
import { useAuth, formatApiError } from "@/context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/app");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 relative iw-noise">
      <div className="w-full max-w-md iw-card p-8 fade-up relative z-10">
        <Link to="/"><Logo /></Link>
        <p className="overline mt-8">Client Portal</p>
        <h1 className="font-display text-3xl font-bold mt-1 mb-6">Sign in</h1>
        <form onSubmit={submit} className="space-y-4">
          <input className="iw-input" type="email" placeholder="Email address" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" />
          <input className="iw-input" type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" />
          <button disabled={loading} className="btn-gold w-full py-3 rounded-full" data-testid="login-submit">{loading ? "Signing in…" : "Sign In"}</button>
        </form>
        <p className="text-sm text-[#8B9BB4] mt-6">No account? <Link to="/register" className="text-[#D4AF37] font-semibold">Create one</Link></p>
      </div>
    </div>
  );
}
